import Icon from '@/components/Icon/Icon';
import { noop, getWindowSize } from '@/utils/util';
import { renderChildren } from '@/components/Menu/MenuUtil';
import Menu, { MenuItem } from '@/components/Menu/';
import classNames from 'classnames';
import React, { Component } from 'react';
import Animate from 'rc-animate';
import styles from './SubMenu.scss';

const winSize = getWindowSize();
class SubMenu extends Component {
  static defaultProps = {
    autoAlign: true,
    onClick: noop,
    direction: 'left',
  };
  state = {
    showMenu: false,
  };

  componentDidMount() {
    this.autoAlignMenu();
  }
  componentDidUpdate() {
    this.autoAlignMenu();
  }
  onMouseEnter = (e) => {
    clearTimeout(this.hideTimer);
    this.setState({ showMenu: true });
  };

  onMouseLeave = (e) => {
    this.hideTimer = setTimeout(() => { this.setState({ showMenu: false }); }, 30);
  };

  onItemClick = (e, itemdata) => {
    const { onClick, index } = this.props;
    onClick(e, itemdata);
  };
  autoAlignMenu = () => {
    const { autoAlign } = this.props;
    // 计算下显示的位置是否合理
    if (autoAlign && this.menuRef) {
      const rect = this.menuRef.getBoundingClientRect();
      if (rect.width && rect.height) {
        let { className } = this.menuRef;
        if ((rect.height + rect.top) > winSize[1]) {
          className = className.replace(new RegExp(styles['submenu-bottom']), '');
          this.menuRef.className = `${className} ${styles['submenu-top']}`;
        }
      }
    }
  }
  render() {
    const { showMenu } = this.state;
    const {
      children,
      iconName,
      text,
      className,
      index,
      direction,
    } = this.props;
    const subMenuClass = classNames(styles['submenu'], styles['submenu-bottom'], {
                            [styles['hidden']]: !showMenu,
                          });
    return (
      <MenuItem
        iconName={iconName}
        className={classNames(className, styles['menuitem'], styles[`menuitem-${direction}`])}
        onClick={this.onItemClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        index={index}
      >
        { text }
        <Animate transitionName='fade' component='div' className={styles['submenu-wrapper']}>
          {
            <Menu
              key="submenu-wrapper"
              className={subMenuClass}
              onClick={this.onItemClick}
              getMenuDom={(v) => {
                this.menuRef = v;
              }}
            >
              { children }
            </Menu>
          }
        </Animate>
      </MenuItem>
    );
  }
}

export default SubMenu;



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/SubMenu.js